export const FULLSCREEN = 'fullscreen';
export const BROWSER = 'browser';
export const STANDALONE = 'standalone';
export const MINIMAL_UI = 'minimal-ui';
export const WINDOW_CONTROLS_OVERLAY = 'window-controls-overlay';